module.exports = __webpack_public_path__ + "media/images/favicons/favicon-sunday-32x32-fa19830546ae1eca10d64d679fc17add.png";